import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Props = { children: ReactNode; className?: string; padding?: 'sm' | 'md' };

export function Card({ children, className, padding = 'md' }: Props) {
  return (
    <div className={cn(
      'rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-900',
      padding === 'sm' ? 'p-3' : 'p-4',
      className,
    )}>
      {children}
    </div>
  );
}
